enum Link {
  HOME = 'home',
  ACTIVITIES = 'activities',
  CARS = 'cars',
  CRUISES = 'cruises',
  FLIGHTS = 'flights',
  PACKAGES = 'packages',
  STAYS = 'stays',
}

export { Link };
